import DatatableController, { responsiveModal, detachButtonGroup } from "./datatable_base"

export default class extends DatatableController {
  get tableSelector() {
    return ".datatables-basic-export"
  }

  datatableOptions() {
    return {
      order: [[0, "desc"]],
      dom: "Bfrtip",
      displayLength: 100,
      lengthMenu: [25, 50, 75, 100],
      buttons: [
        {
          extend: "collection",
          className: "buttonToLink text-green-dark-background",
          text: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="o-ico" title="exports"><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"></path><rect x="6" y="14" width="12" height="8" rx="1"></rect></svg>',
          buttons: [
            {
              extend: "copy",
              text: feather.icons["copy"].toSvg({ class: "font-small-4 me-50" }) + "Copier",
              className: "dropdown-item",
              exportOptions: { columns: "*" }
            }
          ],
          init: detachButtonGroup
        }
      ],
      responsive: responsiveModal(),
      bFilter: false,
      bInfo: false,
      lengthChange: false,
      paging: false,
      ordering: false,
      info: false
    }
  }
}
